import React from "react";
import "./styles.css";
import TileBanner from "../../common-components/tileBanner/TileBanner";
import ContentCard from "../../common-components/contentCard/ContentCard";
import { blogs, projects } from "../../data/homeContent";

const Home = () => {
  const renderSection = (heading, items, ctaLabel) => (
    <section className="home-section" key={heading}>
      <h2 className="home-section__title">{heading}</h2>
      <div className="home-section__items">
        {items.map(({ title, description, link }) => (
          <ContentCard
            key={title}
            title={title}
            description={description}
            link={link}
            ctaLabel={ctaLabel}
          />
        ))}
      </div>
    </section>
  );

  return (
    <div className="home-container">
      <TileBanner />
      {renderSection("Projects", projects, "Explore project")}
      {renderSection("Blogs", blogs, "Read article")}
    </div>
  );
};
export default Home;
